export default "__VITE_ASSET__Bt_tLnNQ__ 400w, __VITE_ASSET__BnM3lxtV__ 800w, __VITE_ASSET__C0HX4p6___ 1024w";